// 2D-profilens udsnit som ren geometri: profilens polylinje (profile.points, x/y i verdenskoordinater) udvidet til profile.width
// (hele bredden, halvdelen til hver side - som profilvinduet selv, se ProfileRequest.js/viewer/profile.js), i ALLE højder.
// Bruges af den direkte LAS-download af profilen (FullPointExport.exportAllPointsInProfile). Ingen THREE her.

// -> [{ax, ay, ux, uy, len, half, minX, minY, maxX, maxY}] - ét rektangel pr. segment (nul-lange segmenter springes over)
export function profileSegments(points, width){
	const half = width / 2;
	const segments = [];

	for(let i = 0; i < points.length - 1; i++){
		const a = points[i];
		const b = points[i + 1];
		const dx = b.x - a.x;
		const dy = b.y - a.y;
		const len = Math.hypot(dx, dy);
		if(!(len > 0)) continue;

		const ux = dx / len;
		const uy = dy / len;
		const nx = -uy * half;
		const ny = ux * half;
		const xs = [a.x + nx, a.x - nx, b.x + nx, b.x - nx];
		const ys = [a.y + ny, a.y - ny, b.y + ny, b.y - ny];

		segments.push({
			ax: a.x, ay: a.y, ux, uy, len, half,
			minX: Math.min(...xs), maxX: Math.max(...xs),
			minY: Math.min(...ys), maxY: Math.max(...ys),
		});
	}

	return segments;
}

// Ligger (x, y) i et af segmenternes rektangler? (et punkt tæller kun én gang, også i overlap ved et knæk)
export function insideProfile(segments, x, y){
	for(let i = 0; i < segments.length; i++){
		const s = segments[i];
		const rx = x - s.ax;
		const ry = y - s.ay;
		const along = rx * s.ux + ry * s.uy;
		if(along < 0 || along > s.len) continue;
		const across = -rx * s.uy + ry * s.ux;
		if(across <= s.half && across >= -s.half) return true;
	}
	return false;
}

// Kan en akse-parallel kasse (xy-udstrækning) berøre profilen? Bruges til at springe oktræ-grene over.
export function boxTouchesProfile(segments, minX, minY, maxX, maxY){
	for(let i = 0; i < segments.length; i++){
		const s = segments[i];
		if(maxX >= s.minX && minX <= s.maxX && maxY >= s.minY && minY <= s.maxY) return true;
	}
	return false;
}
